'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useMountEffect } from '@/hooks/useMountEffect';
export function FlipCursor() {
  const $ = _c(2);
  const label = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let timer;
      let inside = false;
      const hide = () => {
        inside = false;
        clearTimeout(timer);
        if (label.current) {
          label.current.style.transition = "none";
          label.current.style.opacity = "0";
        }
      };
      const move = event => {
        const target = event.target instanceof Element ? event.target : null;
        const page = target?.closest(".rotation-page");
        const face = target?.closest("[data-selected=\"true\"] .rotation-hit, .rotation-back-hit");
        if (event.pointerType !== "mouse" || !face || !target?.closest("[data-pointer-ready=\"true\"]") || page?.dataset.closing === "true") {
          hide();
          return;
        }
        if (label.current) {
          label.current.style.transform = `translate(${event.clientX + 10}px, ${event.clientY + 10}px)`;
        }
        if (inside) {
          return;
        }
        inside = true;
        if (label.current) {
          label.current.style.transition = "opacity 1000ms";
        }
        timer = setTimeout(() => {
          if (label.current) {
            label.current.style.opacity = "1";
          }
        }, 150);
      };
      window.addEventListener("pointermove", move, {
        passive: true
      });
      window.addEventListener("blur", hide);
      document.addEventListener("pointerleave", hide);
      return () => {
        clearTimeout(timer);
        window.removeEventListener("pointermove", move);
        window.removeEventListener("blur", hide);
        document.removeEventListener("pointerleave", hide);
      };
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useMountEffect(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div ref={label} className="rotation-flip-cursor" aria-hidden="true">Flip</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}